<div class="w-6 bg-slate-200 rounded hover:bg-slate-300 cursor-grab">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 6H8.00635M8 12H8.00635M8 18H8.00635M15.9937 6H16M15.9937 12H16M15.9937 18H16" stroke="#64748B" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</div>